import Api from './Api';

export const CommentsApi = {
    async getComments(transactionId, transactionType) {
        try {
            const { response } = await Api.get(`/api/comments?transactionId=${transactionId}&transactionType=${transactionType}`);
            return response || [];
        } catch (error) {
            console.error('Error fetching comments:', error);
            return [];
        }
    },

    async addComment(transactionId, transactionType, text, transactionDescription, transactionAmount) {
        try {
            const { response } = await Api.post('/api/comments', {
                transactionId,
                transactionType,
                text,
                // Sent so the push notification can show the transaction context without a
                // server-side lookup; the client already has these rendered on screen.
                transactionDescription,
                transactionAmount
            });
            return response;
        } catch (error) {
            console.error('Error adding comment:', error);
            throw error;
        }
    },

    async deleteComment(commentId) {
        try {
            const { response } = await Api.delete(`/api/comments/${commentId}`);
            return response;
        } catch (error) {
            console.error('Error deleting comment:', error);
            throw error;
        }
    }
};

export default CommentsApi;